let stripePromise;

export async function getStripe() {
  if (!stripePromise) {
    const { loadStripe } = await import('@stripe/stripe-js');

    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {});
  }
  return stripePromise;
}
